module.exports = __webpack_public_path__ + "static/media/workOrderHeader.9a13ced2.jpg";